import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { getConsent } from "./CookieBanner";

const GA4_ID = process.env.REACT_APP_GA4_ID;
const GTM_ID = process.env.REACT_APP_GTM_ID;
const CLARITY_ID = process.env.REACT_APP_CLARITY_ID;

function loadOnce(id, fn) {
    if (typeof window === "undefined" || window[`__loaded_${id}`]) return;
    window[`__loaded_${id}`] = true;
    fn();
}

function loadTrackers() {
    if (GTM_ID) {
        loadOnce("gtm", () => {
            const s = document.createElement("script");
            s.async = true;
            s.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
            document.head.appendChild(s);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
        });
    }
    if (GA4_ID) {
        loadOnce("ga4", () => {
            const s = document.createElement("script");
            s.async = true;
            s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
            document.head.appendChild(s);
            window.dataLayer = window.dataLayer || [];
            window.gtag = function () { window.dataLayer.push(arguments); };
            window.gtag("js", new Date());
            window.gtag("config", GA4_ID);
        });
    }
    if (CLARITY_ID) {
        loadOnce("clarity", () => {
            (function (c, l, a, r, i, t, y) {
                c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
                t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
                y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
            })(window, document, "clarity", "script", CLARITY_ID);
        });
    }
}

export default function Analytics() {
    const { pathname } = useLocation();
    const grantedRef = useRef(getConsent() === "granted");

    useEffect(() => {
        if (grantedRef.current) loadTrackers();
        const onGrant = () => {
            grantedRef.current = true;
            loadTrackers();
            if (GA4_ID && window.gtag) window.gtag("event", "page_view", { page_path: window.location.pathname });
        };
        window.addEventListener("cookie-consent-granted", onGrant);
        return () => window.removeEventListener("cookie-consent-granted", onGrant);
    }, []);

    useEffect(() => {
        if (grantedRef.current && GA4_ID && window.gtag) {
            window.gtag("event", "page_view", { page_path: pathname });
        }
    }, [pathname]);

    return null;
}
